export enum ContractType {
    ToBeDetermined = 0,
    Permanent = 1,
    Temporary = 2,
}